import { z } from 'zod';

/**
 * Case Wiki run-context inputs.
 *
 * This text belongs to a single analysis run. It is not evidence, not a
 * source, and not a global preference attached to the cabinet or dossier.
 * The shared contract only normalizes the shape; backend code enforces the
 * 10k estimated-token budget.
 */
export const CASE_WIKI_CONTEXT_USER_INPUTS_MAX_TOKENS = 10_000;

/**
 * Shared string primitive for Case Wiki run-context inputs.
 *
 * `.trim()` keeps the prompt text stable across transports. Blank text is
 * collapsed to absence by the body schema so callers can submit an empty box
 * without persisting a meaningless empty string.
 */
export const CaseWikiContextUserInputsSchema = z.string().trim();
export type CaseWikiContextUserInputs = z.infer<typeof CaseWikiContextUserInputsSchema>;

export function normalizeCaseWikiContextUserInputs(value: unknown): string | undefined {
  const parsed = CaseWikiContextUserInputsSchema.optional().parse(value);
  return parsed && parsed.length > 0 ? parsed : undefined;
}

export const CaseWikiContextUserInputsBodySchema = z
  .object({
    case_wiki_context_user_inputs: z.preprocess(
      (value) => normalizeCaseWikiContextUserInputs(value),
      CaseWikiContextUserInputsSchema.optional(),
    ),
  })
  .strict();
export type CaseWikiContextUserInputsBody = z.infer<typeof CaseWikiContextUserInputsBodySchema>;
